<template>
  <section class="aboutus-section">
    <div class="title-and-more">
      <img src="@/assets/img/about-us-icon-1.svg" alt="" />
      <h2>{{ title }}</h2>
    </div>
    <span
      id="aboutus_text"
      class="aboutus_text"
      :class="{ smallAboutUsSize: AboutUsSmall }"
    >
      {{ text }}
    </span>
    <b
      class="more-btn"
      :class="{ morebtnback: !AboutUsSmall }"
      v-if="IsLongAboutUs"
      @click="resizeAboutUs"
      >{{ AboutUsSmall ? "ادامه متن..." : "بستن" }}</b
    >
  </section>
</template>

<script>
export default {
  name: "fullWidthText",
  props: { title: String, text: String },
  data() {
    return {
      IsLongAboutUs: false,
      AboutUsSmall: false,
    };
  },
  methods: {
    resizeAboutUs() {
      if (this.AboutUsSmall == true) {
        this.AboutUsSmall = false;
      } else {
        this.AboutUsSmall = true;
      }
    },
  },
  computed: {
    countLines() {
      var el = document.getElementById("aboutus_text");
      var divHeight = el.offsetHeight;
      return parseInt(divHeight);
    },
  },
  mounted() {
    if (this.countLines > 200) {
      this.IsLongAboutUs = true;
      this.AboutUsSmall = true;
    }
  },
};
</script>
<style lang="css" scoped>
@import url(@/assets/style/components/fullWidthText/fullWidthText.css);
</style>
